// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import { ClientSignedDocumentsList } from '../ClientSignedDocumentsList';

interface PolicySignedDocumentsTabProps {
  readonly policyId: string;
  readonly profileId?: string;
}

/**
 * "Client Signed Documents" tab for the policy detail page. Reuses
 * the relationship-level {@link ClientSignedDocumentsList} but scoped
 * to a single policy via the {@code policyId} prop.
 */
export function PolicySignedDocumentsTab({ policyId, profileId }: PolicySignedDocumentsTabProps) {
  return (
    <ClientSignedDocumentsList
      profileId={profileId ?? ''}
      policyId={policyId}
    />
  );
}
